export default function NotFound() {
  return (
    <div className="container mx-auto my-20 text-center">
      <h1>404</h1>
      <p>There is nothing here</p>
    </div>
  );
}
